import React, { useState, useEffect } from "react";
import { Dropdown, Button, Modal } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logOut } from "../../redux/auth/authSlice";

// React Icons
import { AiOutlineClose } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { blobURL } from "common/StringUtils";
import OuterRightSidebar from "./outer-header/OuterRightSidebar";
import { deleteCookie } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const Header = ({ variant = "primary", color = "primary", bgcolor }) => {
  const mainLogoNew = `${blobURL}/fakt-logo.png`;
  const secondaryLogo = `${blobURL}/secondary-logo.png`;

  const britishFlag = `${blobURL}/britishFlag.jpg`;
  const swedanFlag = `${blobURL}/swedanFlag.png`;
  const headerLogo = `${blobURL}/fakt-logo.png`;

  const [showNavMenu, setShowNavMenu] = useState(false);
  const [showModal, setShowModal] = useState({
    show: false,
  });
  const [flag, setFlag] = useState(swedanFlag);
  const user = useSelector((state) => state.auth.user);
  const [openDropdown, setOpenDropdown] = useState({
    eventKey0: false,
    eventKey1: false,
    eventKey2: false,
    eventKey3: false,
    eventKey4: false,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  let language = localStorage.getItem("i18nextLng");
  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };

  const queryParams = getQueryParams(location.search);
  const invoiceNumber = queryParams.get("invoiceNumber");
  const isAuthorize = queryParams.get("isAuthorize") == "true";

  const changeLanguage = (lng) => {
    const searchParams = new URLSearchParams(location.search);
    const URLLang = searchParams.get("lang");
    const currentPath = location.pathname;
    const baseURL = import.meta.env.VITE_SITE_URL;

    if (lng === language) {
      return;
    } else {
      if (URLLang !== lng) {
        i18n.changeLanguage(lng);

        let newPath = "";

        switch (currentPath) {
          case "/business":
          case "/foretag":
            newPath = lng === LOCALES.EN_US ? `business?lang=${LOCALES.EN_US}` : `foretag?lang=${LOCALES.SV_SE}`;
            break;
          case "/":
            newPath = lng === LOCALES.EN_US ? `?lang=${LOCALES.EN_US}` : `?lang=${LOCALES.SV_SE}`;
            break;
          case "/about-invozio":
          case "/om-invozio":
            newPath =
              lng === LOCALES.EN_US ? `about-invozio?lang=${LOCALES.EN_US}` : `om-invozio?lang=${LOCALES.SV_SE}`;
            break;
          case "/contact-us":
          case "/kontakta-oss":
            newPath =
              lng === LOCALES.EN_US ? `contact-us?lang=${LOCALES.EN_US}` : `kontakta-oss?lang=${LOCALES.SV_SE}`;
            break;
          case "/how-works-invozio":
          case "/hur-fungerar-invozio":
            newPath =
              lng === LOCALES.EN_US
                ? `how-works-invozio?lang=${LOCALES.EN_US}`
                : `hur-fungerar-invozio?lang=${LOCALES.SV_SE}`;
            break;
          case "/function":
          case "/funktion":
            newPath = lng === LOCALES.EN_US ? `function?lang=${LOCALES.EN_US}` : `funktion?lang=${LOCALES.SV_SE}`;
            break;

          case "/ambassador":
            newPath =
              lng === LOCALES.EN_US ? `ambassador?lang=${LOCALES.EN_US}` : `ambassador?lang=${LOCALES.SV_SE}`;
            break;
          case "/freelance-consultant-salary-invoice-without-a-company":
          case "/frilans-konsult-lon-fakturera-utan-foretag":
            newPath =
              lng === LOCALES.EN_US
                ? `freelance-consultant-salary-invoice-without-a-company?lang=${LOCALES.EN_US}`
                : `frilans-konsult-lon-fakturera-utan-foretag?lang=${LOCALES.SV_SE}`;
            break;
          case "/how-much-should-I-invoice-as-a-freelancer":
          case "/hur-mycket-ska-jag-fakturera-som-frilansare":
            newPath =
              lng === LOCALES.EN_US
                ? `how-much-should-I-invoice-as-a-freelancer?lang=${LOCALES.EN_US}`
                : `hur-mycket-ska-jag-fakturera-som-frilansare?lang=${LOCALES.SV_SE}`;
            break;
          case "/insurance":
          case "/forsakring":
            newPath = lng === LOCALES.EN_US ? `insurance?lang=${LOCALES.EN_US}` : `forsakring?lang=${LOCALES.SV_SE}`;
            break;
          case "/self-employment":
          case "/egenanstallning":
            newPath =
              lng === LOCALES.EN_US
                ? `self-employment?lang=${LOCALES.EN_US}`
                : `egenanstallning?lang=${LOCALES.SV_SE}`;
            break;
          case "/start-your-own-business-or-invoice-as-a-private-person":
          case "/starta-eget-foretag-eller-fakturera-som-privatperson":
            newPath =
              lng === LOCALES.EN_US
                ? `start-your-own-business-or-invoice-as-a-private-person?lang=${LOCALES.EN_US}`
                : `starta-eget-foretag-eller-fakturera-som-privatperson?lang=${LOCALES.SV_SE}`;
            break;
          case "/from-invoice-to-negotiation":
          case "/fran-faktura-till-forhandling":
            newPath =
              lng === LOCALES.EN_US
                ? `from-invoice-to-negotiation?lang=${LOCALES.EN_US}`
                : `fran-faktura-till-forhandling?lang=${LOCALES.SV_SE}`;
            break;
          case "/emailregister":
          case "/e-postregister":
            newPath =
              lng === LOCALES.EN_US ? `emailregister?lang=${LOCALES.EN_US}` : `e-postregister?lang=${LOCALES.SV_SE}`;
            break;
          case "/emaillogin":
          case "/e-postinloggning":
            newPath =
              lng === LOCALES.EN_US ? `emaillogin?lang=${LOCALES.EN_US}` : `e-postinloggning?lang=${LOCALES.SV_SE}`;
            break;
          case "/forgot-password":
          case "/glomt-ditt-losenord":
            newPath =
              lng === LOCALES.EN_US
                ? `forgot-password?lang=${LOCALES.EN_US}`
                : `glomt-ditt-losenord?lang=${LOCALES.SV_SE}`;
            break;
          case "/login":
          case "/logga-in":
            newPath = lng === LOCALES.EN_US ? `login?lang=${LOCALES.EN_US}` : `logga-in?lang=${LOCALES.SV_SE}`;
            break;

          case "/pension":
            newPath = lng === LOCALES.EN_US ? `pension?lang=${LOCALES.EN_US}` : `pension?lang=${LOCALES.SV_SE}`;
            break;

          case "/private-healthcare-insurance":
          case "/privatvardsforsakring":
            newPath =
              lng === LOCALES.EN_US
                ? `private-healthcare-insurance?lang=${LOCALES.EN_US}`
                : `privatvardsforsakring?lang=${LOCALES.SV_SE}`;
            break;

          case "/dashboard/private-healthcare-insurance":
          case "/instrumentbrada/privatvardsforsakring":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/private-healthcare-insurance?lang=${LOCALES.EN_US}`
                : `instrumentbrada/privatvardsforsakring?lang=${LOCALES.SV_SE}`;
            break;

          case "/dashboard/activities":
          case "/instrumentbrada/aktiviteter":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/activities?lang=${LOCALES.EN_US}`
                : `instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/invoice-tool":
          case "/instrumentbrada/faktura-verktyg":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/invoice-tool?lang=${LOCALES.EN_US}`
                : `instrumentbrada/faktura-verktyg?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/time-sheet":
          case "/instrumentbrada/tidrapport":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/time-sheet?lang=${LOCALES.EN_US}`
                : `instrumentbrada/tidrapport?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/invoices":
          case "/instrumentbrada/ekonomi/fakturor":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/invoices?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/fakturor?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/customers":
          case "/instrumentbrada/ekonomi/kunder":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/customers?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/kunder?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/freelancers":
          case "/instrumentbrada/ekonomi/frilansare":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/freelancers?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/frilansare?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/created-time-sheets":
          case "/instrumentbrada/ekonomi/skapade-tidrapporter":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/created-time-sheets?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/skapade-tidrapporter?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/preliminary-invoices":
          case "/instrumentbrada/ekonomi/preliminara-fakturor":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/preliminary-invoices?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/preliminara-fakturor?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/salaries":
          case "/instrumentbrada/ekonomi/loner":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/salaries?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/loner?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/pension":
          case "/instrumentbrada/ekonomi/pension":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/pension?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/pension?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/pension":
          case "/instrumentbrada/pension":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/pension?lang=${LOCALES.EN_US}`
                : `instrumentbrada/pension?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/holiday-pay":
          case "/instrumentbrada/ekonomi/semesterlon":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/holiday-pay?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/semesterlon?lang=${LOCALES.SV_SE}`;
            break;            
          case "/dashboard/economy/supplier-ledgers":
          case "/instrumentbrada/ekonomi/leverantorsreskontra":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/supplier-ledgers?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/leverantorsreskontra?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/employer-certificates":
          case "/instrumentbrada/ekonomi/arbetsgivarcertifikat":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/employer-certificates?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/arbetsgivarcertifikat?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/agreements":
          case "/instrumentbrada/ekonomi/avtal":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/agreements?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/avtal?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/terms-and-conditions":
          case "/instrumentbrada/ekonomi/villkor":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/terms-and-conditions?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/villkor?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/incomestatements":
          case "/instrumentbrada/ekonomi/inkomstredovisningar":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/incomestatements?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/inkomstredovisningar?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/settings/personal-information":
          case "/instrumentbrada/installningar/personlig-information":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/settings/personal-information?lang=${LOCALES.EN_US}`
                : `instrumentbrada/installningar/personlig-information?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/settings/bank-information":
          case "/instrumentbrada/installningar/bankinformation":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/settings/bank-information?lang=${LOCALES.EN_US}`
                : `instrumentbrada/installningar/bankinformation?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/settings/change-password":
          case "/instrumentbrada/installningar/andra-losenord":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/settings/change-password?lang=${LOCALES.EN_US}`
                : `instrumentbrada/installningar/andra-losenord?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/insurances":
          case "/instrumentbrada/forsakring":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/insurances?lang=${LOCALES.EN_US}`
                : `instrumentbrada/forsakring?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/good-working-conditions":
          case "/instrumentbrada/bra-arbetsvillkor":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/good-working-conditions?lang=${LOCALES.EN_US}`
                : `instrumentbrada/bra-arbetsvillkor?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/calculator-anchor":
          case "/instrumentbrada/kalkylator-ankare":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/calculator-anchor?lang=${LOCALES.EN_US}`
                : `instrumentbrada/kalkylator-ankare?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/ambassador":
          case "/instrumentbrada/ambassador":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/ambassador?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ambassador?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/function":
          case "/instrumentbrada/funktion":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/function?lang=${LOCALES.EN_US}`
                : `instrumentbrada/funktion?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/faq":
          case "/instrumentbrada/faq":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/faq?lang=${LOCALES.EN_US}`
                : `instrumentbrada/faq?lang=${LOCALES.SV_SE}`;
            break;
          case "/faq":
            newPath = lng === LOCALES.EN_US ? `faq?lang=${LOCALES.EN_US}` : `faq?lang=${LOCALES.SV_SE}`;
            break;
          case "/set-new-password":
          case "/set-nytt-losenord":
            newPath =
              lng === LOCALES.EN_US
                ? `set-new-password?lang=${LOCALES.EN_US}`
                : `set-nytt-losenord?lang=${LOCALES.SV_SE}`;
            break;
          case "/cookies":
            newPath = lng === LOCALES.EN_US ? `cookies?lang=${LOCALES.EN_US}` : `cookies?lang=${LOCALES.SV_SE}`;
            break;
          case "/working-as-a-freelancer-and-invoicing-without-tax-registration":
          case "/att-jobba-som-frilansare-och-fakturera-utan-fskatt":
            newPath =
              lng === LOCALES.EN_US
                ? `working-as-a-freelancer-and-invoicing-without-tax-registration?lang=${LOCALES.EN_US}`
                : `att-jobba-som-frilansare-och-fakturera-utan-fskatt?lang=${LOCALES.SV_SE}`;
            break;
            case "/invoicing-without-company-2025":
              case "/fakturering-utan-foretag-2025":
                newPath =
                  lng === LOCALES.EN_US
                    ? `invoicing-without-company-2025?lang=${LOCALES.EN_US}`
                    : `fakturering-utan-foretag-2025?lang=${LOCALES.SV_SE}`;
                break;
            case "/freelance-freelancing":
            case "/frilans-frilansarbete":
            newPath =
              lng === LOCALES.EN_US
                ? `freelance-freelancing?lang=${LOCALES.EN_US}`
                : `frilans-frilansarbete?lang=${LOCALES.SV_SE}`;
            break;
          case "/invoicing-as-an-individual_self-employed":
          case "/fakturera-som-privatperson_egenanstalld":
            newPath =
              lng === LOCALES.EN_US
                ? `invoicing-as-an-individual_self-employed?lang=${LOCALES.EN_US}`
                : `fakturera-som-privatperson_egenanstalld?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/economy/worked-hours":
          case "/instrumentbrada/ekonomi/arbetade-timmar":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/economy/worked-hours?lang=${LOCALES.EN_US}`
                : `instrumentbrada/ekonomi/arbetade-timmar?lang=${LOCALES.SV_SE}`;
            break;
          case "/health-insurance-main":
          case "/sjukforsakring-huvud":
            newPath =
              lng === LOCALES.EN_US
                ? `health-insurance-main?lang=${LOCALES.EN_US}`
                : `sjukforsakring-huvud?lang=${LOCALES.SV_SE}`;
            break;
          case "/health-insurance":
          case "/sjukforsakring":
            newPath =
              lng === LOCALES.EN_US
                ? `health-insurance?lang=${LOCALES.EN_US}`
                : `sjukforsakring?lang=${LOCALES.SV_SE}`;
            break;
          case "/dashboard/health-insurance":
          case "/instrumentbrada/sjukforsakring":
            newPath =
              lng === LOCALES.EN_US
                ? `dashboard/health-insurance?lang=${LOCALES.EN_US}`
                : `instrumentbrada/sjukforsakring?lang=${LOCALES.SV_SE}`;
            break;

          case "/invoice-without-company-or-business":
          case "/fakturera-utan-foretag-eller-bolag":
            newPath =
              lng === LOCALES.EN_US
                ? `invoice-without-company-or-business?lang=${LOCALES.EN_US}`
                : `fakturera-utan-foretag-eller-bolag?lang=${LOCALES.SV_SE}`;
            break;
          case "/invoice-as-consultant-salary":
          case "/fakturera-som-konsult-lon":
            newPath =
              lng === LOCALES.EN_US
                ? `invoice-as-consultant-salary?lang=${LOCALES.EN_US}`
                : `fakturera-som-konsult-lon?lang=${LOCALES.SV_SE}`;
            break;            
          case "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger":
            newPath =
              lng === LOCALES.EN_US
                ? `recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger?lang=${LOCALES.EN_US}`
                : `recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger?lang=${LOCALES.SV_SE}`;
            break;            
          case "/frilans-finans-vs-Invozio":
            newPath =
              lng === LOCALES.EN_US
                ? `frilans-finans-vs-Invozio?lang=${LOCALES.EN_US}`
                : `frilans-finans-vs-Invozio?lang=${LOCALES.SV_SE}`;
            break;            
          case "/cool-company-vs-Invozio":
            newPath =
              lng === LOCALES.EN_US
                ? `cool-company-vs-Invozio?lang=${LOCALES.EN_US}`
                : `cool-company-vs-Invozio?lang=${LOCALES.SV_SE}`;
            break;            
          case "/gigger-vs-Invozio":
            newPath =
              lng === LOCALES.EN_US
                ? `gigger-vs-Invozio?lang=${LOCALES.EN_US}`
                : `gigger-vs-Invozio?lang=${LOCALES.SV_SE}`;
            break;            
          default:
            newPath = "";
          // Add more cases as needed
        }
        if (newPath) {
          navigate(`/${newPath}`);
        }
        if (
          currentPath.includes("/thankyou") ||
          currentPath.includes("/tack")
        ) {
          const id = currentPath.split("?")[0].split("/")[2];

          if (lng === LOCALES.EN_US) {
            window.location.replace(`${baseURL}thankyou/${id}?lang=${LOCALES.EN_US}`);
          } else if (lng === LOCALES.SV_SE) {
            window.location.replace(`${baseURL}tack/${id}?lang=${LOCALES.SV_SE}`);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (language === LOCALES.EN_US) {
      setFlag(britishFlag);
    } else {
      setFlag(swedanFlag);
    }
  }, [language, britishFlag, swedanFlag]);

  const closeInvoiceTool = () => {
    setShowModal({
      show: false,
      showCloseTimeSheet: false,
    });
    if (language === LOCALES.EN_US) {
      navigate(`/dashboard/activities?lang=${LOCALES.EN_US}`);
    } else {
      navigate(`/instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`);
    }
  };

  return (
    <div className="her_chngs">
      <header
        className={
          bgcolor
            ? "headerBgColor new_header_css"
            : "home_header new_header_css"
        }
      >
        {variant === "secondary" && (
          <nav className="px-3 py-1 d-flex justify-content-end align-items-center ">
            <Dropdown className="ml-2">
              <Dropdown.Toggle
                variant="primary"
                size="sm"
                className="bg-light border-light  text-dark"
              >
                <i className="fi fi-se" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="#">
                  <i className="fi fi-se" />
                </Dropdown.Item>
                <Dropdown.Item href="#">
                  <i className="fi fi-se" />
                </Dropdown.Item>
                <Dropdown.Item href="#">
                  <i className="fi fi-se" />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </nav>
        )}
        <div
          className={
            location.pathname === "/"
              ? "d-flex align-items-center justify-content-between py-4 px-3 bg-light container-fluid"
              : "d-flex align-items-center justify-content-between py-3 px-3 container-fluid"
          }
        >
          <div className="d-flex align-items-end sitelogo w-100 position-relative">
            <div className="logo_new mr-5">
              {!bgcolor && (
                <img
                  className={`mr-md-4 mr-2 logo cursor-pointer img-fluid${
                    color === "primary" ? "" : ""
                  }`}
                  src={bgcolor ? secondaryLogo : mainLogoNew}
                  alt="site-logo"
                  onClick={() => {
                    const currentUrl = window.location.pathname;
                    if (currentUrl.includes("dashboard")) {
                      navigate(`/dashboard/activities?lang=${LOCALES.EN_US}`);
                    } else if (currentUrl.includes("instrumentbrada")) {
                      navigate(`/instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`);
                    } else {
                      navigate(language === LOCALES.EN_US ? `/?lang=${LOCALES.EN_US}` : `/?lang=${LOCALES.SV_SE}`);
                    }
                  }}
                  height="auto"
                  width="auto"
                />
              )}
              <Link
                style={{ textDecoration: "underline" }}
                to="/"
                aria-label="Go to Homepage"
              >
                <img
                  src={headerLogo}
                  alt="site-logo"
                  className="img-fluid logo-top"
                />
              </Link>
            </div>

            <div className="responive_view d-flex align-items-center">
              {(location.pathname.includes("function") ||
              location.pathname.includes("funktion") ||
              location.pathname.includes("pension") ||
              location.pathname.includes("sjukforsakring") ||
              location.pathname.includes("health-insurance") ||
              location.pathname.includes("privatvardsforsakring") ||
              location.pathname.includes("sjukforsakring-huvud") ||
              location.pathname.includes("health-insurance-main") ||
              location.pathname.includes("private-healthcare-insurance")
                ? !user
                : true) &&
                !location.pathname.includes("dashboard") &&
                !location.pathname.includes("instrumentbrada") && (
                  <>
                    <nav>
                      <ul
                        className={
                          location.pathname === "/"
                            ? "free_lancer circle"
                            : "free_lancer"
                        }
                        onClick={() => {
                          navigate(
                            language === LOCALES.EN_US ? `/?lang=${LOCALES.EN_US}` : `/?lang=${LOCALES.SV_SE}`
                          );
                        }}
                      >
                        <li className="p-0">
                          <Link to="/" className="link-tabs">
                            {t("Freelancer")}
                          </Link>
                        </li>
                      </ul>

                      <ul
                        className={
                          location.pathname === "/business" ||
                          location.pathname === "/foretag"
                            ? "free_lancer circle"
                            : "free_lancer"
                        }
                        onClick={() => {
                          language === LOCALES.EN_US
                            ? navigate(`/business?lang=${LOCALES.EN_US}`)
                            : navigate(`/foretag?lang=${LOCALES.SV_SE}`);
                        }}
                      >
                        <li className="p-0">
                          <Link to="/" className="link-tabs">
                            {t("Business")}
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </>
                )}
            </div>
          </div>
          <div className="m-0 d-flex align-items-center select-country w-100 justify-content-end">
            {user ? (
              <>
                {!location.pathname.includes("dashboard") &&
                  !location.pathname.includes("pension") &&
                  !location.pathname.includes("health-insurance") &&
                  !location.pathname.includes("sjukforsakring") &&
                  !location.pathname.includes("sjukforsakring-huvud") &&
                  !location.pathname.includes("health-insurance-main") &&
                  !location.pathname.includes("instrumentbrada") &&
                  !location.pathname.includes("function") &&
                  !location.pathname.includes("private-healthcare-insurance") &&
                  !location.pathname.includes("privatvardsforsakring") &&
                  !location.pathname.includes("funktion") && (
                    <Button
                      style={{
                        color: !bgcolor && "#535353",
                      }}
                      size="md"
                      className={`show-only-desktop mx-2  go_to_dashboard_btn`}
                      onClick={() => {
                        if (language === LOCALES.EN_US) {
                          navigate(`/dashboard/activities?lang=${LOCALES.EN_US}`);
                        } else {
                          navigate(`/instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`);
                        }
                      }}
                    >
                      {t("Go to Dashboard")}
                    </Button>
                  )}
                {/* <Button
                  style={{
                    color: !bgcolor && "#535353",
                  }}
                  size="md"
                  className={`show-only-desktop mx-2  sign_in_btn`}
                  onClick={() => {
                    dispatch(logOut());
                    toast.success(t("Logged out successfully"));
                    deleteCookie("logged");
                  }}
                >
                  {t("View Tour Guide")}
                  <span> <IoPlayForwardCircleOutline /> </span>
                </Button> */}

                <Button
                  style={{
                    color: !bgcolor && "#535353",
                  }}
                  size="md"
                  className={`show-only-desktop mx-2  sign_in_btn`}
                  onClick={() => {
                    dispatch(logOut());
                    toast.success(t("Logged out successfully"));
                    deleteCookie("logged");
                  }}
                >
                  {t("Sign out")}
                </Button>

                {(location.pathname === "/dashboard/invoice-tool" ||
                  location.pathname === "/instrumentbrada/faktura-verktyg") && (
                  <>
                    <Button
                      variant="outline-primary"
                      className=" bg-light d-none d-lg-block cit web-tool add_in"
                      size="lg"
                      onClick={() =>
                        setShowModal({
                          show: true,
                        })
                      }
                    >
                      {t("Close Invoice Tool")}
                    </Button>

                    <Button
                      variant=""
                      className="ml-0 pt-0 px-0 text-light d-lg-none text-primary pb-0"
                      size="lg"
                      onClick={() =>
                        setShowModal({
                          show: true,
                        })
                      }
                    >
                      <AiOutlineClose
                        className="text-primary"
                        size={24}
                      ></AiOutlineClose>
                    </Button>
                  </>
                )}

                {(location.pathname === "/dashboard/time-sheet" ||
                  location.pathname === "/instrumentbrada/tidrapport") && (
                  <>
                    <Button
                      variant="outline-primary"
                      className=" bg-light d-none d-lg-block"
                      size="lg"
                      onClick={() =>
                        setShowModal({
                          show: true,
                          showCloseTimeSheet: true,
                        })
                      }
                    >
                      {t("Close Timesheet")}
                    </Button>

                    <Button
                      variant=""
                      className="ml-0 pt-0 px-0 text-light d-lg-none text-primary pb-0"
                      size="lg"
                      onClick={() =>
                        setShowModal({
                          show: true,
                        })
                      }
                    >
                      <AiOutlineClose
                        className="text-primary"
                        size={24}
                      ></AiOutlineClose>
                    </Button>
                  </>
                )}
              </>
            ) : (
              <>
                <Dropdown className="show-only-desktop outer-header-link">
                  <Dropdown.Toggle
                    variant="primery"
                    className="create_account_drop"
                  >
                    {t("Create Free Account")}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      value={1}
                      onClick={(e) => {
                        navigate(
                          language === LOCALES.EN_US
                            ? `/emailregister?lang=${LOCALES.EN_US}`
                            : `/e-postregister?lang=${LOCALES.SV_SE}`
                        );
                        sessionStorage.setItem("accountType", 1);
                      }}
                    >
                      {t("For freelance & consultant")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      defaultValue={2}
                      onClick={(e) => {
                        navigate(
                          language === LOCALES.EN_US
                            ? `/emailregister?lang=${LOCALES.EN_US}`
                            : `/e-postregister?lang=${LOCALES.SV_SE}`
                        );
                        sessionStorage.setItem("accountType", 2);
                      }}
                    >
                      {t("For Business")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Button
                  style={{
                    color: !bgcolor && "#535353",
                  }}
                  size="md"
                  className={`show-only-desktop mx-2  sign_in_btn`}
                  onClick={() => {
                    if (invoiceNumber) {
                      navigate(
                        language === LOCALES.EN_US
                          ? `/emaillogin?lang=${LOCALES.EN_US}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=true`
                          : `/e-postinloggning?lang=${LOCALES.SV_SE}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=true`
                      );
                    } else {
                      navigate(
                        language === LOCALES.EN_US ? `/emaillogin?lang=${LOCALES.EN_US}` : `/e-postinloggning?lang=${LOCALES.SV_SE}`
                      );
                    }
                  }}
                >
                  {t("Sign in")}
                </Button>
              </>
            )}

            <Dropdown>
              <Dropdown.Toggle className={!bgcolor && "custom-dropdown"}>
                <img
                  width="25"
                  height="20"
                  src={flag}
                  alt="Select Language"
                  loading="lazy"
                />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  href="#"
                  onClick={() => changeLanguage(LOCALES.SV_SE)}
                  className="text-dark"
                >
                  <img
                    src={swedanFlag}
                    alt="Swedish"
                    width="25"
                    height="20"
                    loading="lazy"
                  />
                </Dropdown.Item>
                <Dropdown.Item
                  href="#"
                  onClick={() => changeLanguage(LOCALES.EN_US)}
                  className="text-dark"
                >
                  <img
                    src={britishFlag}
                    alt="English"
                    width="25"
                    height="20"
                    loading="lazy"
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <span
              className={`burger-menu text-light cursor-pointer ml-2 ${
                color === "primary" ? "" : ""
              }`}
              onClick={() => setShowNavMenu(true)}
            >
              <span> ☰ </span>
            </span>
          </div>
        </div>

        <Modal
          show={showModal.show}
          onHide={() =>
            setShowModal({
              show: false,
            })
          }
        >
          <Modal.Header>
            <Modal.Title> {t("Close Invoice Tool")} </Modal.Title>
            <AiOutlineClose
              className="ml-auto cursor-pointer"
              size={24}
              onClick={() =>
                setShowModal({
                  show: false,
                })
              }
            />
          </Modal.Header>
          <Modal.Body>
            <span>
              {t(
                "Are you sure you want to close the invoice tool? All changes will be removed."
              )}
            </span>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="outline_btn_new"
              variant="secondary"
              onClick={() =>
                setShowModal({
                  show: false,
                })
              }
            >
              {t("No")}
            </button>
            <Button
              className="text-light save_add_customer new_theme_btn"
              onClick={closeInvoiceTool}
            >
              {t("Yes")}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showModal.showCloseTimeSheet}
          onHide={() =>
            setShowModal({
              show: false,
              showCloseTimeSheet: false,
            })
          }
        >
          <Modal.Header>
            <Modal.Title> {t("Close Timesheet")} </Modal.Title>
            <AiOutlineClose
              className="ml-auto cursor-pointer"
              size={24}
              onClick={() =>
                setShowModal({
                  show: false,
                })
              }
            />
          </Modal.Header>
          <Modal.Body>
            {t(
              "Are you sure you want to close the invoice tool? All changes will be removed."
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="outline_btn_new"
              variant="secondary"
              onClick={() =>
                setShowModal({
                  show: false,
                })
              }
            >
              {t("No")}
            </button>
            <Button
              className="text-light save_add_customer new_theme_btn"
              onClick={closeInvoiceTool}
            >
              {t("Yes")}
            </Button>
          </Modal.Footer>
        </Modal>
      </header>

      <OuterRightSidebar
        showNavMenu={showNavMenu}
        setShowNavMenu={setShowNavMenu}
        user={user}
        language={language}
        openDropdown={openDropdown}
        setOpenDropdown={setOpenDropdown}
        setShowModal={setShowModal}
      />

      {!location.pathname.includes("dashboard") &&
        !location.pathname.includes("instrumentbrada") && (
          <div className="hidden_header">
            <div className="respn_tab d-flex align-items-center justify">
              <>
                <ul
                  className={
                    location.pathname === "/"
                      ? "free_lancer circle"
                      : "free_lancer"
                  }
                  onClick={() => {
                    navigate(language === LOCALES.EN_US ? `/?lang=${LOCALES.EN_US}` : `/?lang=${LOCALES.SV_SE}`);
                  }}
                >
                  <li className="p-0">
                    <Link
                      style={{ textDecoration: "underline" }}
                      to="/"
                      className="hidden-header mb-0"
                    >
                      {t("Freelancer")}
                    </Link>
                  </li>
                </ul>
                <ul
                  className={
                    location.pathname === "/business" ||
                    location.pathname === "/foretag"
                      ? "free_lancer circle"
                      : "free_lancer"
                  }
                  onClick={() => {
                    language === LOCALES.EN_US
                      ? navigate(`/business?lang=${LOCALES.EN_US}`)
                      : navigate(`/foretag?lang=${LOCALES.SV_SE}`);
                  }}
                >
                  <li className="p-0">
                    <Link
                      style={{ textDecoration: "underline" }}
                      to="/"
                      className="hidden-header mb-0 businss_hrd"
                    >
                      {t("Business")}
                    </Link>
                  </li>
                </ul>
              </>
            </div>
          </div>
        )}
    </div>
  );
};

export default Header;
